import styles from "./Splitter.module.scss";

export const Splitter = () => {
    return <div className={styles.splitter} />;
}